import React from 'react';
import skillsImg from './skill-hat.svg';
import timerImg from './timer.svg';
import starsImg from './stars.svg';
import skillCountImg from './cert-star.svg';

const CourseDetail = (props) => {

  const completeCourse = (courseId, e) => {

    e.preventDefault();

    let courses = JSON.parse(localStorage.getItem('courses'));
    if (typeof courses === 'undefined' || courses === null ) {
      courses = [];
    }

    let skills = JSON.parse(localStorage.getItem('skills'));
    if (typeof skills === 'undefined' || skills === null ) {
      skills = [];
    }

    skills = skills.concat(props.skills.split(',').map(s => {
      return s.trim()
    }));
    skills = skills.filter(function(item, i, ar){ return ar.indexOf(item) === i; });
    courses.push(courseId);

    localStorage.setItem('courses', JSON.stringify(courses));
    localStorage.setItem('skills', JSON.stringify(skills));

    window.location = `/certificate/${courseId}`;
  }

  const styles = {
    backgroundColor: '#DBFD0C',
    position: 'relative',
    maxWidth: '320px',
    minWidth: '320px',
    width: '80vw',
    margin: '0 auto',
    padding: '1em 0'
  }
  const skillCount = props.skills.split(',').length;

  return (
    <div>
      <div className="courseAttributes">
        <div className="attIcon">
          <img src={skillsImg} alt=""/>
        </div>
        <div className="attribute">
          <span className="gigDetailSkills">
            { props.skills }
          </span>
        </div>

        <div className="courseStars">
          <img src={starsImg} alt=""/>
        </div>

      </div>

      <div className="courseAttributes">
        <div className="attIcon"><img src={timerImg} alt=""/></div>
        <div className="hoursText attribute pullUp8">
          <span>{ props.duration }</span>
          <span className="hoursLabel">HRS</span>
        </div>
        <div className="attIcon"><img src={skillCountImg} alt=""/></div>
        <div className="attribute ">
          <div> { skillCount } </div>
          <div>SKILL{ skillCount > 1 ? 'S' : null }</div>
        </div>
      </div>
      <div className="courseDone">
        <span href="#" onClick={completeCourse.bind(this, props.courseId) }>
          COURSE COMPLETED
        </span>
      </div>
    </div>
  );
}

export default CourseDetail;



// WEBPACK FOOTER //
// ./src/components/CourseDetail/index.js